









import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';

const minMilliseconds = 60 * 1000;
const hourMilliseconds = 60 * minMilliseconds;
const dayMilliseconds = 24 * hourMilliseconds;

@Component
export default class CountDownComponent extends Vue {
  @Prop({ required: true })
  start: string;

  timer = 0;

  countdown = 0;

  get days() {
    return Math.floor(this.countdown / dayMilliseconds);
  }

  get hours() {
    return Math.floor((this.countdown % dayMilliseconds) / hourMilliseconds);
  }

  get minutes() {
    return Math.floor((this.countdown % hourMilliseconds) / minMilliseconds);
  }

  get seconds() {
    return Math.floor((this.countdown % minMilliseconds) / 1000);
  }

  mounted() {
    this.setCounter();
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  setCounter() {
    this.timer = setInterval(() => {
      this.countdown = moment(this.start).valueOf() - moment().valueOf();

      if (this.countdown <= 0) {
        this.countdown = 0;
        clearInterval(this.timer);
      }
    }, 1000);
  }
}
